import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/PersonelProfil.css";
import "../styles/EgitimCard.css";
import EgitimStep from "./EgitimStep";
import axios from "axios";

const egitimKartlari = [
  {
    id: 1,
    adi: "İSG Genel Konular",
    gorsel: "/images/isg.jpeg",
    aciklama: "İş sağlığı ve güvenliği temel modülleri",
    moduller: [
      { id: 1, ad: "Başlangıç", video: "/videos/0-1.mp4" },
      { id: 2, ad: "Tanım", video: "/videos/1-1.mp4" },
      { id: 3, ad: "Mevzuat", video: "/videos/1-2.mp4" },
      { id: 4, ad: "Hak ve Sorumluluklar", video: "/videos/1-3.mp4" },
      { id: 5, ad: "Düzen", video: "/videos/1-4.mp4" },
      { id: 6, ad: "Hukuki Sonuçlar", video: "/videos/1-5.mp4" },
    ],
  },
  {
    id: 2,
    adi: "İSG Sağlık Konuları",
    gorsel: "/images/isgsaglik.jpg",
    aciklama: "İş sağlığı ile ilgili konular",
    moduller: [
      { id: 1, ad: "Meslek Hastalıkları", video: "/videos/2-1.mp4" },
      { id: 2, ad: "Hastalıktan Korunma", video: "/videos/2-2.mp4" },
      { id: 3, ad: "Risk Etmenleri", video: "/videos/2-3.mp4" },
      { id: 4, ad: "İlk Yardım", video: "/videos/2-4.mp4" },
      { id: 5, ad: "Tütü Ürünleri", video: "/videos/2-5.mp4" },
    ],
  },
  {
    id: 3,
    adi: "İSG Teknik Konular",
    gorsel: "/images/isgtknık.jpeg",
    aciklama: "Bu kartın açıklaması",
    moduller: [
      { id: 1, ad: "Risk", video: "/videos/3-1.mp4" },
      { id: 2, ad: "Taşıma", video: "/videos/3-2.mp4" },
      { id: 3, ad: "Koruma", video: "/videos/3-3.mp4" },
      { id: 4, ad: "Kullanım", video: "/videos/3-4.mp4" },
      { id: 5, ad: "Çalışma", video: "/videos/3-5.mp4" },
      { id: 6, ad: "Önlemler", video: "/videos/3-6.mp4" },
      { id: 7, ad: "İşaretler", video: "/videos/3-7.mp4" },
      { id: 8, ad: "KKD", video: "/videos/3-8.mp4" },
      { id: 9, ad: "Tahliye", video: "/videos/3-9.mp4" },
    ],
  },
  {
    id: 4,
    adi: "İSG Güvenli Çalış",
    gorsel: "/images/sagliklicalis.jpeg",
    aciklama: "İş sağlığı ve güvenliği genel eğitimi",
    moduller: [
      { id: 1, ad: "Genel Eğitim", video: "/videos/Guvenlicalis.mp4" },
    ],
  },
];

const PersonelProfil = () => {
  const location = useLocation();
  const modulTamamlandi = location.state?.modulTamamlandi;

  const [aktifMenu, setAktifMenu] = useState("egitimler");
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [tamamlanmaDurumlari, setTamamlanmaDurumlari] = useState({});
  const [profilePhoto, setProfilePhoto] = useState(null);

  // Sertifika görseli + büyük popup
  const [sertifikaFoto, setSertifikaFoto] = useState(null);
  const [buyukSertifika, setBuyukSertifika] = useState(null);

  // Modül 4 uyarı popup
  const [showModul4Warning, setShowModul4Warning] = useState(false);
  const [modul4WarningMessage, setModul4WarningMessage] = useState("");

  const kullaniciAdi = localStorage.getItem("userName") || "Personel";
  const kullaniciMail = localStorage.getItem("userEmail") || "E-posta";
  const token = localStorage.getItem("token");

  // Sertifika foto
  useEffect(() => {
    const fetchSertifikaFoto = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/VerilenSertifika/benim-foto`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          }
        );

        const imgUrl = URL.createObjectURL(res.data);
        setSertifikaFoto(imgUrl);
      } catch (err) {
        console.error("Sertifika fotoğrafı alınamadı:", err);
        setSertifikaFoto(null);
      }
    };

    if (token) {
      fetchSertifikaFoto();
    }
  }, [token]);

  // Profil foto
  useEffect(() => {
    const fetchProfilePhoto = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          }
        );
        const imgUrl = URL.createObjectURL(res.data);
        setProfilePhoto(imgUrl);
      } catch (err) {
        console.error("Profil fotoğrafı alınamadı:", err);
      }
    };
    if (token) fetchProfilePhoto();
  }, [token]);

  // Modül tamamlama durumları
  useEffect(() => {
    const fetchTamamlanmaDurumlari = async () => {
      try {
        const durumlar = {};
        for (const egitim of egitimKartlari) {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/Isg/getir?modulId=${egitim.id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          durumlar[egitim.id] = res.data.basariDurumu;
        }
        setTamamlanmaDurumlari(durumlar);
      } catch (err) {
        console.error("Tamamlanma durumları alınamadı:", err);
      }
    };
    if (token) fetchTamamlanmaDurumlari();
  }, [token]);

  // Router'dan gelen "modulTamamlandi" bilgisi
  useEffect(() => {
    if (modulTamamlandi) {
      setTamamlanmaDurumlari((prev) => ({
        ...prev,
        [modulTamamlandi]: true,
      }));
    }
  }, [modulTamamlandi]);

  // Başla / Tamamlandı butonu
  const handleKatil = async (egitim) => {
    // 4. modül kilit kontrolü
    if (egitim.id === 4) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Isg/modul4-aktif-mi`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = res.data;
        const aktif = data.modul4Aktif === true;

        if (!aktif) {
          const eksikIds =
            data.eksikModuller?.$values ||
            data.eksikModuller?.values ||
            data.eksikModuller ||
            [];

          let mesaj = "";

          if (Array.isArray(eksikIds) && eksikIds.length > 0) {
            const eksikAdlar = eksikIds
              .map((id) => {
                const kart = egitimKartlari.find((e) => e.id === id);
                return kart ? kart.adi : `Modül ${id}`;
              })
              .filter(Boolean);

            mesaj = `"${egitim.adi}" modülüne geçmeden önce şu eğitimleri tamamlamalısınız: ${eksikAdlar.join(
              ", "
            )}.`;
          } else {
            mesaj = `"${egitim.adi}" modülüne geçmeden önce önceki eğitimleri tamamlamalısınız.`;
          }

          setModul4WarningMessage(mesaj);
          setShowModul4Warning(true);
          return;
        }
      } catch (err) {
        console.error("modul4-aktif-mi kontrol hatası:", err);
      }
    }

    setSeciliEgitim(egitim);
  };

  const renderIcerik = () => {
    switch (aktifMenu) {
      case "egitimler":
        return (
          <div className="personel-icerik">
            <h2>Eğitimlerim</h2>
            <div className="egitim-card-list">
              {egitimKartlari.map((egitim) => {
                const tamamlandi = !!tamamlanmaDurumlari[egitim.id];
                const butonMetin = tamamlandi ? "Tamamlandı" : "Başla";

                return (
                  <div className="egitim-kart" key={egitim.id}>
                    <div className="egitim-kart-header">
                      <img
                        src={egitim.gorsel || "/images/default.jpg"}
                        alt="Eğitim Görsel"
                        className="egitim-kart-gorsel"
                      />
                    </div>
                    <div className="egitim-kart-alt">
                      <div className="egitim-logo">
                        <img src="/images/fulla.png" alt="Logo" />
                      </div>
                      <div className="egitim-baslik">{egitim.adi}</div>
                      <div className="egitim-butonu">
                        <button onClick={() => handleKatil(egitim)}>
                          {butonMetin}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case "sertifikalar":
        return (
          <div className="personel-icerik">
            <h2>Sertifikalarım</h2>
            <div className="sertifika-kart-wrapper">
              {sertifikaFoto ? (
                <div
                  className="sertifika-kart sertifika-kucuk"
                  onClick={() => setBuyukSertifika(sertifikaFoto)}
                >
                  <img
                    src={sertifikaFoto}
                    alt="Sertifika"
                    className="sertifika-img"
                  />
                </div>
              ) : (
                <p className="sertifika-bos-mesaj">
                  Henüz tanımlı bir sertifikanız bulunmamaktadır.
                </p>
              )}
            </div>
          </div>
        );

      default:
        return <div className="personel-icerik">İçerik seçilmedi.</div>;
    }
  };

  return (
    <div className="personel-container">
      <div className="personel-sidebar">
        <div className="personel-user-info">
          <div className="personel-avatar">
            {profilePhoto ? (
              <img src={profilePhoto} alt="Profil" />
            ) : (
              <div className="navbar-user-photo-placeholder">👤</div>
            )}
          </div>
          <h3>{kullaniciAdi}</h3>
          <p>{kullaniciMail}</p>
        </div>

        <ul className="personel-menu">
          <li
            className={aktifMenu === "egitimler" ? "aktif" : ""}
            onClick={() => setAktifMenu("egitimler")}
          >
            📘 Eğitimlerim
          </li>
          <li
            className={aktifMenu === "sertifikalar" ? "aktif" : ""}
            onClick={() => setAktifMenu("sertifikalar")}
          >
            🎓 Sertifikalarım
          </li>
          <li
            className={aktifMenu === "videolar" ? "aktif" : ""}
            onClick={() => setAktifMenu("videolar")}
          >
            🎥 Videolarım
          </li>
          <li
            className={aktifMenu === "benim" ? "aktif" : ""}
            onClick={() => setAktifMenu("benim")}
          >
            ⭐ Benim Menüm
          </li>
          <li
            className={aktifMenu === "kariyer" ? "aktif" : ""}
            onClick={() => setAktifMenu("kariyer")}
          >
            💼 Kariyerim
          </li>
        </ul>
      </div>

      <div className="personel-content">{renderIcerik()}</div>

      {seciliEgitim && (
        <div className="egitim-modal-overlay1">
          <div className="egitim-modal">
            <button className="modal-close" onClick={() => setSeciliEgitim(null)}>
              ✖
            </button>
            <EgitimStep
              egitim={seciliEgitim}
              onClose={() => setSeciliEgitim(null)}
            />
          </div>
        </div>
      )}

      {buyukSertifika && (
        <div
          className="sertifika-popup-overlay"
          onClick={() => setBuyukSertifika(null)}
        >
          <div className="sertifika-popup">
            <img src={buyukSertifika} alt="Sertifika Büyük" />
          </div>
        </div>
      )}

      {showModul4Warning && (
        <div className="modul-uyari-overlay">
          <div className="modul-uyari-popup">
            <p>{modul4WarningMessage}</p>
            <button onClick={() => setShowModul4Warning(false)}>Tamam</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonelProfil;
